import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const WashingMachineIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <defs>
        <path
          d="M1.77635684e-15,6.839 C1.77635684e-15,10.615 3.194,13.676 7.137,13.676 L7.137,13.676 C11.079,13.676 14.273,10.615 14.273,6.839 L14.273,6.839 C14.273,3.062 11.079,0 7.137,0 L7.137,0 C3.194,0 1.77635684e-15,3.062 1.77635684e-15,6.839"
          id="washing-machine-path-1"
        ></path>
      </defs>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(10.000000, 5.000000)">
          <g>
            <path
              d="M30.91,37.32 C30.91,38.485 29.966,39.428 28.801,39.428 L2.108,39.428 C0.944,39.428 0,38.485 0,37.32 L0,2.107 C0,0.944 0.944,0 2.108,0 L28.801,0 C29.966,0 30.91,0.944 30.91,2.107 L30.91,37.32 Z"
              fill="#ffffff"
              className={styles.white}
            ></path>
            <path
              d="M30.91,37.32 C30.91,38.485 29.966,39.428 28.801,39.428 L2.108,39.428 C0.944,39.428 0,38.485 0,37.32 L0,2.107 C0,0.944 0.944,0 2.108,0 L28.801,0 C29.966,0 30.91,0.944 30.91,2.107 L30.91,37.32 Z"
              stroke="#000000"
              className={styles.defaultStrokeColor}
              strokeLinejoin="round"
              strokeWidth="2"
            ></path>
            <path
              d="M27.8161,4.0741 C27.8161,4.6811 27.3241,5.1731 26.7171,5.1731 C26.1111,5.1731 25.6181,4.6811 25.6181,4.0741 C25.6181,3.4671 26.1111,2.9761 26.7171,2.9761 C27.3241,2.9761 27.8161,3.4671 27.8161,4.0741 Z"
              stroke="#000000"
              className={styles.defaultStrokeColor}
              strokeLinejoin="round"
            ></path>
            <path
              d="M24.2457,4.0741 C24.2457,4.6811 23.7537,5.1731 23.1467,5.1731 C22.5397,5.1731 22.0487,4.6811 22.0487,4.0741 C22.0487,3.4671 22.5397,2.9761 23.1467,2.9761 C23.7537,2.9761 24.2457,3.4671 24.2457,4.0741 Z"
              stroke="#000000"
              className={styles.defaultStrokeColor}
              strokeLinejoin="round"
            ></path>
            <path
              d="M24.6635,23.2909 C24.6635,28.2549 20.6375,32.2809 15.6725,32.2809 C10.7075,32.2809 6.6825,28.2549 6.6825,23.2909 C6.6825,18.3249 10.7075,14.2999 15.6725,14.2999 C20.6375,14.2999 24.6635,18.3249 24.6635,23.2909 Z"
              stroke="#000000"
              className={styles.defaultStrokeColor}
              strokeLinejoin="round"
              strokeWidth="2"
            ></path>
            <path
              d="M14.183,22.1703 C14.183,22.1703 13.435,22.1413 13.523,22.9533"
              stroke="#FFFFFF"
              className={styles.whiteStroke}
              strokeWidth="0.295"
            ></path>
            <line
              stroke="#000000"
              className={styles.defaultStrokeColor}
              strokeLinejoin="round"
              x1="0"
              x2="30.91"
              y1="7.7865"
              y2="7.7865"
            ></line>
          </g>
          <g transform="translate(8.554000, 16.626600)">
            <mask fill="#ffffff" className={styles.white} id="washing-machine-mask-1">
              <use xlinkHref="#washing-machine-path-1"></use>
            </mask>
            <path
              d="M-3.5028,5.0519 C-3.5028,5.0519 -0.1648,5.7629 1.0912,5.9149 C2.3482,6.0679 2.6872,4.8479 4.1382,5.0519 C5.5892,5.2549 5.6862,6.0589 6.9432,5.4779 C8.2002,4.8989 8.4422,4.2439 9.7962,5.0289 C11.1512,5.8139 11.0032,5.8719 12.7942,5.9289 C14.5872,5.9849 16.7612,4.6309 17.3412,5.2989 C17.9212,5.9669 16.9052,13.2829 13.3752,13.9939 C9.8452,14.7059 3.2672,14.3499 3.2672,14.3499 C3.2672,14.3499 -1.4238,11.0979 -1.5688,10.9459 C-1.7138,10.7929 -3.5028,5.0519 -3.5028,5.0519"
              fill="#0050B3"
              className={styles.interactiveColor}
              mask="url(#washing-machine-mask-1)"
            ></path>
          </g>
        </g>
      </g>
    </Icon>
  )
}
